import React from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay'
import { useNodes } from 'hooks/relay'
import { Divider, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Condition from 'components/Condition'
import Box from 'components/Box'
import InfoMessage from 'components/InfoMessage'
import { ReferencesTab_ReferencesQuery } from '__generated__/ReferencesTab_ReferencesQuery.graphql'
import ReferencesEditor from './components/ReferencesEditor'
import ReferenceCard from './components/ReferenceCard'

export interface IReferencesTabProps {
  editable: boolean
  userId: string
}

function ReferencesTab(props: IReferencesTabProps) {
  const { editable, userId } = props
  const theme = useTheme()

  const referencesData = useLazyLoadQuery<ReferencesTab_ReferencesQuery>(
    graphql`
      query ReferencesTab_ReferencesQuery($userId: ID!) {
        user: node(id: $userId) {
          ... on User {
            references (status: completed) {
              id
              ...ReferenceCard_Reference
            }
          }
        }
      }
    `,
    {
      userId,
    },
    {
      fetchPolicy: 'store-and-network',
    },
  )

  const user = referencesData?.user
  const references = useNodes(user?.references)

  return (
    <Box data-cy="profile-references">
      <Grid container spacing={2}>
        <Condition condition={references.length === 0}>
          <Grid item xs={12}>
            <InfoMessage>
              No references to show at this time.
            </InfoMessage>
          </Grid>
        </Condition>

        {references.map(reference => (
          <Grid key={reference.id} item xs={12}>
            <ReferenceCard referenceFragmentRef={reference} />
          </Grid>
        ))}
      </Grid>

      <Condition condition={editable}>
        <Divider style={{ margin: theme.spacing(4, -4) }} />
        <ReferencesEditor />
      </Condition>
    </Box>
  )
}

export default React.memo(ReferencesTab)
